import DatePickerMonths from './DatePickerMonths';
import DatePickerYears from './DatePickerYears';
import { getMonth, getYear } from 'date-fns';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import Button from '../../Button';

interface DatePickerHeaderProps {
  monthDate: Date;
  customHeaderCount: number;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  changeMonth: (month: number) => void;
  changeYear: (year: number) => void;
}

const DatePickerHeader = ({
  monthDate,
  customHeaderCount,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
  changeMonth,
  changeYear,
}: DatePickerHeaderProps) => {
  const isFirstMonth = customHeaderCount === 0;

  if (isFirstMonth) {
    return (
      <div className='flex gap-5 rounded-t bg-white p-2'>
        <Button
          variant='outlined'
          size='condensed'
          color='secondary'
          icon={<ArrowBackIcon />}
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        />

        <div className='flex space-x-2.5'>
          <DatePickerMonths
            selectedMonth={getMonth(monthDate)}
            setSelectedMonth={changeMonth}
          />
          <DatePickerYears
            selectedYear={getYear(monthDate)}
            setSelectedYear={changeYear}
          />
        </div>
      </div>
    );
  }

  return (
    <div className='flex justify-end gap-5 rounded-t bg-white p-2'>
      <div className='flex space-x-2.5'>
        <DatePickerMonths
          selectedMonth={getMonth(monthDate)}
          setSelectedMonth={changeMonth}
        />
        <DatePickerYears
          selectedYear={getYear(monthDate)}
          setSelectedYear={changeYear}
        />
      </div>

      <Button
        variant='outlined'
        size='condensed'
        color='secondary'
        icon={<ArrowForwardIcon />}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      />
    </div>
  );
};

export default DatePickerHeader;
